"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const OverlayTooltip_1 = tslib_1.__importDefault(require("core/components/OverlayTooltip"));
const TagButton = ({ isSelected, colorTheme, onClick, disabled, text }) => {
    return ((0, jsx_runtime_1.jsx)("button", { className: `btn border-${colorTheme || 'primary'} ${isSelected ? 'bg-primary text-white' : 'bg-white'} m-1 btn-sm`, disabled: disabled, onClick: onClick, children: (0, jsx_runtime_1.jsx)(OverlayTooltip_1.default, { content: text, children: text.length > 30 ? text.substring(0, 30) + '...' : text }) }));
};
exports.default = TagButton;
